/* TRIGRRR Night: the theme's one script.
   Motion comes from the design system: reveals, the scroll scenes (the box hero, the unboxing film),
   tickers and the nav that steps aside. The rest is the store: the Shopify cart, the order slip,
   the sourcing file, the first-order note and the goodness page.
   Kept to plain ASCII on purpose (non-ASCII text is written as \u escapes). */
(function () {
  "use strict";

  var CFG = window.TRIGRRR || {};
  var routes = CFG.routes || {};
  var MONEY = String(CFG.moneyFormat || "Rs. {{amount}}").replace(/<[^>]*>/g, "");
  var FREE = Math.round((CFG.freeShippingThreshold == null ? 500 : +CFG.freeShippingThreshold) * 100);
  var SHIP = Math.round((CFG.shippingFee == null ? 49 : +CFG.shippingFee) * 100);
  var ORDER = ["yellow", "white", "green", "brown"];

  /* the four products, written by the layout from Theme settings > Flavours */
  var CATALOG = {};
  try { CATALOG = JSON.parse(document.getElementById("tg-catalog").textContent) || {}; } catch (e) {}
  var BY_HANDLE = {};
  ORDER.forEach(function (id) { if (CATALOG[id] && CATALOG[id].handle) BY_HANDLE[CATALOG[id].handle] = id; });

  /* ------------------------------------------------------------ helpers */
  function qsa(root, sel) {
    var out = [].slice.call((root || document).querySelectorAll(sel));
    if (root && root.matches && root.matches(sel)) out.unshift(root);
    return out;
  }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function h(tag, attrs, kids) {
    var el = document.createElement(tag), k, v;
    if (attrs) for (k in attrs) {
      v = attrs[k];
      if (v == null || v === false) continue;
      if (k === "class") el.className = v; else el.setAttribute(k, v === true ? "" : v);
    }
    add(el, kids);
    return el;
  }
  function add(el, k) {
    if (k == null || k === false) return;
    if (Array.isArray(k)) { for (var i = 0; i < k.length; i++) add(el, k[i]); return; }
    el.appendChild(typeof k === "object" ? k : document.createTextNode(String(k)));
  }
  function setText(root, sel, v) { var x = root.querySelector(sel); if (x) x.textContent = v; }
  function reduced() { return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  /* Shopify money formats, written out the way money_without_trailing_zeros prints them */
  function group(cents, dec, th, dp) {
    var parts = (cents / 100).toFixed(dec).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return parts.length > 1 && parts[1] !== "00" ? parts[0] + dp + parts[1] : parts[0];
  }
  function money(cents) {
    cents = Math.round(cents || 0);
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(MONEY), v;
    if (!m) return group(cents, 2, ",", ".");
    switch (m[1]) {
      case "amount_no_decimals": v = group(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": v = group(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": v = group(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": v = group(cents, 2, "'", "."); break;
      case "amount_with_space_separator": v = group(cents, 2, " ", ","); break;
      default: v = group(cents, 2, ",", ".");
    }
    return MONEY.replace(m[0], v);
  }
  function tierPct(n) { return n >= 4 ? 15 : n === 3 ? 10 : n === 2 ? 5 : 0; }
  function sized(url, w) { return url ? url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w : url; }

  var toastT = 0;
  function toast(msg) {
    var t = document.getElementById("tg-toast");
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 3200);
  }

  /* ----------------------------------------------------- the Shopify cart */
  var cartAddUrl = (routes.cartAdd || "/cart/add") + ".js";
  var cartChangeUrl = (routes.cartChange || "/cart/change") + ".js";
  var cartJsUrl = (routes.cartUrl || "/cart") + ".js";

  function post(url, body) {
    return fetch(url, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function fetchCart() {
    return fetch(cartJsUrl, { credentials: "same-origin", headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  /* Every cart request runs one at a time, in tap order, so a double tap or a slow network
     never sends a change worked out from an out-of-date cart. */
  var cartQueue = Promise.resolve(), currentCart = null, lastFocus = null;
  function queueCart(task) {
    var run = cartQueue.then(task, task);
    cartQueue = run.catch(function () {});
    return run;
  }

  /* 18 Oct 2026: tell Klaviyo who this visitor is when they give us an email, so its Abandoned Cart flow can reach
     them (the forms themselves post to Shopify, which Klaviyo only syncs later and without the browser link).
     Waits for Klaviyo at most 0.8 s, then carries on either way. */
  function klaviyoIdentify(email, done) {
    var fired = false;
    function go() { if (!fired) { fired = true; done(); } }
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === "function") {
        var p = window.klaviyo.identify({ email: email });
        if (p && p.then) p.then(go, go);
      } else { (window._learnq = window._learnq || []).push(["identify", { $email: email }]); }
    } catch (e) {}
    setTimeout(go, 800);
  }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || f.id !== "tg-signup-form" || f._klDone) return;
    var em = f.querySelector('input[type="email"], input[name="contact[email]"]');
    if (!em || !em.value) return;
    e.preventDefault();
    klaviyoIdentify(em.value.trim(), function () { f._klDone = true; f.submit(); });
  }, true);

  function openCart(on) {
    var open = on !== false;
    qsa(document, "[data-tg-cart]").forEach(function (d) {
      if ((d.getAttribute("data-open") === "true") === open) return;
      d.setAttribute("data-open", open ? "true" : "false");
      if (open) {
        lastFocus = document.activeElement;
        var c = d.querySelector(".tg-cart__close");
        if (c) setTimeout(function () { c.focus(); }, 80);
      } else if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
    });
    document.documentElement.classList.toggle("tg-locked", open);
  }

  function renderCart(cart) {
    if (!cart || !cart.items) return;
    currentCart = cart;
    var n = cart.item_count || 0;
    var sub = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
    var after = cart.total_price;
    /* 17 Oct 2026: the box tiers (2 = 5%, 3 = 10%, 4+ = 15%) are real Shopify automatic discounts now, so the bag
       shows what Shopify applied instead of working it out again (that would take the discount twice).
       Automatic (tier) discounts go on the Multi-box line; anything else (a code) on the discount line. */
    var tierOff = 0;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.type === "automatic") tierOff += a.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.type === "automatic") tierOff += a.total_allocated_amount || 0; });
    var code = Math.max(0, (sub - after) - tierOff);
    var pct = tierOff > 0 ? tierPct(n) : 0, off = tierOff, total = after;
    var free = after >= FREE, grand = n ? total + (free ? 0 : SHIP) : 0;
    var applied = (cart.cart_level_discount_applications || []).filter(function (a) { return a.type !== "automatic"; })[0];

    qsa(document, "[data-bag-count]").forEach(function (b) { b.textContent = String(n); });
    qsa(document, "[data-bagfab]").forEach(function (f) { f.hidden = !n; });
    qsa(document, "[data-tg-cart]").forEach(function (d) {
      var list = d.querySelector("[data-cart-lines]");
      if (list) {
        list.textContent = "";
        if (!n) add(list, h("li", { class: "tg-cart__empty" }, "nothing in here yet. the collection is a scroll away."));
        cart.items.forEach(function (it) {
          var fid = BY_HANDLE[it.handle] || null, info = fid && CATALOG[fid];
          var img = info && info.box ? info.box : sized(it.image, 200);
          add(list, h("li", { class: "tg-cart__line", "data-flavour": fid }, [
            img ? h("img", { src: img, alt: "", loading: "lazy" }) : h("span", { class: "tg-cart__noimg", "aria-hidden": "true" }),
            h("span", { class: "tg-cart__name" }, [it.product_title, h("small", null, (info && info.toffee ? info.toffee + " · " : (it.variant_title ? it.variant_title + " · " : "")) + money(it.price))]),
            h("span", { class: "tg-stepper tg-stepper--s", role: "group", "aria-label": it.product_title + " quantity" }, [
              h("button", { type: "button", "data-cart-step": "-1", "data-key": it.key, "aria-label": "One less " + it.product_title }, "−"),
              h("output", null, String(it.quantity)),
              h("button", { type: "button", "data-cart-step": "1", "data-key": it.key, "aria-label": "One more " + it.product_title }, "+")
            ]),
            h("span", { class: "tg-cart__amt" }, money(it.line_price))
          ]));
        });
      }
      setText(d, "[data-cart-ship]", !n ? "free shipping over " + money(FREE) + "." : free ? "free shipping unlocked. nothing else to do." : money(FREE - after) + " away from free shipping.");
      var bar = d.querySelector("[data-cart-bar]");
      if (bar) bar.style.width = (n ? Math.min(100, after / FREE * 100) : 0) + "%";
      setText(d, "[data-cart-sub]", money(sub));
      var codeRow = d.querySelector("[data-cart-coderow]");
      if (codeRow) {
        codeRow.hidden = !(code > 0);
        setText(d, "[data-cart-codelabel]", (applied && applied.title) || "Discount");
        setText(d, "[data-cart-code]", "− " + money(code));
      }
      setText(d, "[data-cart-offlabel]", pct ? "Multi-box (" + pct + "%)" : "Multi-box");
      setText(d, "[data-cart-off]", pct ? "− " + money(off) : "—");
      setText(d, "[data-cart-shipline]", !n ? "—" : free ? "Free" : money(SHIP));
      setText(d, "[data-cart-total]", money(grand));
      qsa(d, "[data-cart-checkout]").forEach(function (a) { a.setAttribute("aria-disabled", String(!n)); });
    });
  }

  /* resolves with the cart on success, or null when nothing was added */
  function addToCart(items, btn) {
    if (btn) {
      if (btn.getAttribute("aria-busy") === "true") return Promise.resolve(null);
      btn.setAttribute("aria-busy", "true");
    }
    return queueCart(function () {
      return post(cartAddUrl, { items: items }).then(function (res) {
        if (res && res.status) {
          toast(res.description || "That could not be added to your bag.");
          return fetchCart().then(function (c) { renderCart(c); return null; });
        }
        return fetchCart().then(function (c) { renderCart(c); openCart(true); return c; });
      });
    }).catch(function () {
      toast("Something went wrong — please try again.");
      return null;
    }).then(function (r) {
      if (btn) btn.removeAttribute("aria-busy");
      return r;
    });
  }

  function stepLine(key, delta) {
    queueCart(function () {
      /* the new quantity comes from the latest cart, not from what was on screen when tapped */
      var it = currentCart && currentCart.items.filter(function (i) { return i.key === key; })[0];
      if (!it) return null;
      return post(cartChangeUrl, { id: key, quantity: Math.max(0, it.quantity + delta) }).then(function (c) {
        if (c && c.items) return renderCart(c);
        toast((c && c.description) || "That could not be changed.");
        return fetchCart().then(renderCart);
      });
    }).catch(function () {
      toast("Something went wrong — please try again.");
      return fetchCart().then(renderCart).catch(function () {});
    });
  }

  function refreshCart() { return queueCart(function () { return fetchCart().then(renderCart); }).catch(function () {}); }

  function variantFor(id) { return CATALOG[id] && CATALOG[id].available !== false ? CATALOG[id].variantId : null; }

  /* ---------------------------------------------------------- order slip */
  function wireOrder(el) {
    if (el._tgOrder) return;
    el._tgOrder = true;
    var counts = {};
    qsa(el, "[data-qty]").forEach(function (o) { counts[o.getAttribute("data-qty")] = +o.textContent || 0; });
    /* the slip is dated today, whatever day the page was cached */
    var now = new Date();
    setText(el, "[data-slip-date]", now.getDate() + " " + ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"][now.getMonth()] + " " + now.getFullYear());
    function price(id) { return (CATALOG[id] && CATALOG[id].price) || 0; }
    function render() {
      var n = 0, sub = 0, lines = el.querySelector("[data-lines]");
      Object.keys(counts).forEach(function (id) {
        n += counts[id]; sub += counts[id] * price(id);
        setText(el, '[data-qty="' + id + '"]', String(counts[id]));
      });
      var pct = tierPct(n), off = Math.round(sub * pct / 100);
      qsa(el, "[data-tier]").forEach(function (t) { var tn = +t.getAttribute("data-tier"); t.setAttribute("aria-current", String(n > 0 && tn === Math.min(n, 4))); });
      if (lines) {
        lines.textContent = "";
        if (!n) add(lines, h("li", { class: "tg-slip__empty" }, "nothing picked yet."));
        ORDER.forEach(function (id) {
          if (!counts[id]) return;
          var name = (CATALOG[id] && CATALOG[id].title) || id;
          add(lines, h("li", null, [h("span", null, counts[id] + " × " + name.toUpperCase()), h("span", null, money(counts[id] * price(id)))]));
        });
      }
      setText(el, "[data-sub]", money(sub));
      setText(el, "[data-off]", pct ? "− " + money(off) + " (" + pct + "%)" : "—");
      setText(el, "[data-ship]", !n ? "—" : sub >= FREE ? "Free" : money(SHIP));
      setText(el, "[data-total]", money(n ? sub - off + (sub >= FREE ? 0 : SHIP) : 0));
      setText(el, "[data-hint]", n === 0 ? "add two boxes to start saving →" : n === 1 ? "one more box and the discount kicks in." : n < 4 ? "add " + (4 - n) + " more for the full 15%." : "maximum goodness discount. we wish we could do more.");
    }
    el.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-step]");
      if (b && el.contains(b)) {
        var id = b.getAttribute("data-for");
        counts[id] = Math.max(0, Math.min(20, (counts[id] || 0) + (+b.getAttribute("data-step"))));
        render();
        return;
      }
      b = e.target.closest && e.target.closest("[data-order-add]");
      if (b && el.contains(b)) {
        var items = ORDER.filter(function (id) { return counts[id] > 0 && variantFor(id); }).map(function (id) { return { id: variantFor(id), quantity: counts[id] }; });
        if (!items.length) { replayOne(el.querySelector("[data-hint]")); return; }
        addToCart(items, b).then(function (c) {
          if (!c) return;
          Object.keys(counts).forEach(function (id) { counts[id] = 0; });
          render();
        });
      }
    });
    render();
  }

  /* ------------------------------------------------- the unboxing film */
  /* One webp per frame, named <base>-01.webp ... -NN.webp. Frames start loading when the scene is
     a screen away; the canvas always shows the nearest frame that has arrived. */
  var films = [];
  function prepFilm(sec) {
    var c = sec.querySelector("canvas[data-film]");
    if (!c || c._tg) return;
    var first = c.getAttribute("data-film"), count = +c.getAttribute("data-frames") || 1;
    var st = { c: c, sec: sec, ctx: c.getContext("2d"), imgs: [], ok: [], last: -1, loading: false, count: count, first: first, gen: 0 };
    c._tg = st;
    films.push(st);
    function load() {
      if (st.loading) return;
      st.loading = true;
      var gen = st.gen, base = st.first;
      for (var i = 0; i < count; i++) (function (i) {
        var im = new Image();
        im.decoding = "async";
        im.onload = function () { if (gen !== st.gen) return; st.ok[i] = true; drawFilm(sec, true); };
        im.src = i === 0 ? base : base.replace(/-01\.webp/, "-" + (i < 9 ? "0" : "") + (i + 1) + ".webp");
        st.imgs[i] = im;
      })(i);
    }
    st.load = load;
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { load(); io.disconnect(); } }, { rootMargin: "120% 0px" });
      io.observe(sec);
    } else load();
  }
  function drawFilm(sec, force) {
    var c = sec.querySelector("canvas[data-film]"), st = c && c._tg;
    var p = parseFloat(sec.style.getPropertyValue("--open")) || 0;
    qsa(sec, ".tg-unbox__note").forEach(function (n) { n.setAttribute("data-on", String(p >= +n.getAttribute("data-at"))); });
    setText(sec, "[data-unbox-pct]", Math.round(p * 100) + "%");
    setText(sec, "[data-unbox-hint]", p >= 0.99 ? "open. there are twelve." : p > 0.02 ? "keep going ↓" : "scroll to open the box ↓");
    if (!st) return;
    var want = Math.round(p * (st.count - 1)), i = -1, d;
    for (d = 0; d < st.count; d++) {
      if (st.ok[want - d]) { i = want - d; break; }
      if (st.ok[want + d]) { i = want + d; break; }
    }
    if (i < 0 || (i === st.last && !force)) return;
    st.last = i;
    st.ctx.clearRect(0, 0, c.width, c.height);
    st.ctx.drawImage(st.imgs[i], 0, 0, c.width, c.height);
    if (c.parentNode && c.parentNode.classList) c.parentNode.classList.add("is-ready");
  }
  /* the hero's arrows: swap the film for another flavour's (its frames load straight away) */
  function stepFilm(btn) {
    var sec = btn.closest("[data-tg-unbox]"), c = sec && sec.querySelector("canvas[data-film]"), st = c && c._tg;
    if (!st) return;
    var opts = qsa(sec, "[data-film-option]"), cur = 0;
    opts.forEach(function (o, i) { if (!o.hidden) cur = i; });
    var nx = opts[(cur + (+btn.getAttribute("data-film-step")) + opts.length) % opts.length];
    opts.forEach(function (o) { o.hidden = o !== nx; });
    sec.setAttribute("data-flavour", nx.getAttribute("data-film-option"));
    st.gen++; st.first = nx.getAttribute("data-film-url"); st.imgs = []; st.ok = []; st.last = -1; st.loading = false;
    st.load();
  }

  /* -------------------------------------------------------- the engine */
  function live() { return document.documentElement.classList.contains("tg-live"); }
  function replayOne(el) {
    if (!el) return;
    if (!live()) { el.setAttribute("data-tg-in", ""); return; }
    el.removeAttribute("data-tg-in"); void el.offsetWidth; el.setAttribute("data-tg-in", "");
  }
  function phasesOf(el) {
    var raw = el.getAttribute("data-tg-phases") || "";
    if (el._tgPh && el._tgPh.raw === raw) return el._tgPh.list;
    var list = raw.split(",").map(function (s) {
      var m = /^\s*([a-z][\w-]*)\s*:\s*([\d.]+)\s*-\s*([\d.]+)\s*$/i.exec(s);
      return m ? { n: m[1], a: +m[2], b: +m[3] } : null;
    }).filter(Boolean);
    el._tgPh = { raw: raw, list: list };
    return list;
  }

  var REDUCE = reduced();
  var scrubs = [], rises = [], navs = [], pending = [], observer = null;

  function update(sec) {
    var vh = window.innerHeight;
    var top = sec.getBoundingClientRect().top;
    var span = sec.offsetHeight - vh;
    var p = REDUCE ? 1 : span > 0 ? clamp(-top / span) : (top < 0 ? 1 : 0);
    sec.style.setProperty("--p", p.toFixed(4));
    phasesOf(sec).forEach(function (ph) { sec.style.setProperty("--" + ph.n, clamp((p - ph.a) / (ph.b - ph.a)).toFixed(4)); });
    sec.setAttribute("data-tg-done", p > 0.92 ? "true" : "false");
    if (sec.hasAttribute("data-tg-unbox")) drawFilm(sec);
    if (sec.hasAttribute("data-tg-rise")) {
      var lit = 0;
      for (var bi = 1; bi < 4; bi++) if ((parseFloat(sec.style.getPropertyValue("--b" + bi)) || 0) >= 0.9) lit = bi + 1;
      if ((parseFloat(sec.style.getPropertyValue("--good")) || 0) >= 0.5) lit = 5;
      sec.setAttribute("data-lit", String(lit));
    }
  }
  /* the fan gets the space under the copy (stacked layouts) and its real height, so boxes are sized to fit */
  function layoutRise(sec) {
    var stage = sec.querySelector(".tg-rise__stage"), copy = sec.querySelector(".tg-rise__copy"), fan = sec.querySelector(".tg-rise__fan");
    if (!stage || !copy || !fan) return;
    var st = stage.getBoundingClientRect(), cr = copy.getBoundingClientRect();
    sec.style.setProperty("--fan-top", Math.round(cr.bottom - st.top + 18) + "px");
    sec.style.setProperty("--fan-h", Math.max(120, Math.round(fan.getBoundingClientRect().height)) + "px");
  }
  function layoutRises() { rises.forEach(layoutRise); }

  /* safety net: anything on screen the observer has not caught yet is revealed on the next frame */
  function sweepReveals() {
    if (!pending.length) return;
    var vh = window.innerHeight;
    pending = pending.filter(function (el) {
      if (el.hasAttribute("data-tg-in")) return false;
      var r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh * 0.92 && (r.width || r.height)) { el.setAttribute("data-tg-in", ""); return false; }
      return true;
    });
  }

  var lastY = window.scrollY || 0, raf = 0;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      scrubs.forEach(update);
      var y = window.scrollY;
      navs.forEach(function (n) { n.setAttribute("data-hidden", String(y > lastY && y > 120 && !document.documentElement.classList.contains("tg-locked"))); });
      lastY = y;
      sweepReveals();
    });
  }
  function onResize() { layoutRises(); scrubs.forEach(update); }

  function init(root) {
    root = root || document;
    var html = document.documentElement;
    if (!REDUCE) html.classList.add("tg-live");

    /* tickers: duplicate the content once so -50% loops seamlessly */
    qsa(root, ".tg-ticker__track").forEach(function (t) {
      if (t.getAttribute("data-tg-dup")) return;
      t.setAttribute("data-tg-dup", "1");
      [].slice.call(t.children).forEach(function (c) { var k = c.cloneNode(true); k.setAttribute("aria-hidden", "true"); t.appendChild(k); });
    });

    /* reveals */
    var revs = qsa(root, "[data-tg-reveal]").filter(function (el) { return !el.hasAttribute("data-tg-in"); });
    if (REDUCE || !("IntersectionObserver" in window)) revs.forEach(function (e) { e.setAttribute("data-tg-in", ""); });
    else {
      if (!observer) observer = new IntersectionObserver(function (entries, o) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.setAttribute("data-tg-in", ""); o.unobserve(en.target); } });
      }, { threshold: 0.22, rootMargin: "0px 0px -8% 0px" });
      revs.forEach(function (el) { observer.observe(el); });
      pending = pending.concat(revs);
      setTimeout(sweepReveals, 1200);
    }

    /* scenes, rises and the nav are tracked page-wide so a section reloaded in the editor joins in */
    scrubs = qsa(document, "[data-tg-scrub]");
    rises = qsa(document, "[data-tg-rise]");
    navs = qsa(document, "[data-tg-nav]");
    layoutRises();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
    setTimeout(onResize, 900);

    qsa(root, "[data-tg-order]").forEach(wireOrder);
    qsa(root, "[data-tg-unbox]").forEach(function (sec) { prepFilm(sec); });
    qsa(root, "[data-tg-goodness]").forEach(wireGoodness);
    qsa(root, "[data-tg-bin]").forEach(wireBin);
    qsa(root, "[data-tg-trigger]").forEach(wireTrigger);
    qsa(root, "[data-tg-claim]").forEach(wireClaim);
    scrubs.forEach(update);
  }

  /* ------------------------------------------------ the first-order note */
  var EXIT_KEY = "trigrrrExitModalDismissed";
  function wireExit() {
    var x = document.querySelector("[data-tg-exit]");
    if (!x || x._tg) return;
    x._tg = true;
    function open() {
      if (x._shown) return;
      x._shown = true;
      x.setAttribute("data-open", "true");
      var f = x.querySelector(".tg-exit__form input, [data-exit-copy], .tg-exit__close");
      if (f) setTimeout(function () { f.focus(); }, 120);
    }
    x._close = function () {
      x.setAttribute("data-open", "false");
      try { localStorage.setItem(EXIT_KEY, "1"); } catch (e) {}
    };
    /* One field takes an email or a mobile number. An email goes through the customer form
       (subscriber list); a number goes through the contact form (store inbox). */
    var form = x.querySelector("[data-exit-signup]");
    if (form) form.addEventListener("submit", function (e) {
      e.preventDefault();
      var input = form.querySelector("input"), raw = (input.value || "").trim();
      var digits = raw.replace(/[\s\-()]/g, "").replace(/^(\+?91|0)(?=\d{10}$)/, "");
      var target = null, err = x.querySelector("[data-exit-error]");
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw)) {
        document.querySelector("[data-exit-email]").value = raw;
        target = document.getElementById("ExitModalEmailForm");
      } else if (/^[6-9]\d{9}$/.test(digits)) {
        document.querySelector("[data-exit-phone]").value = "+91" + digits;
        target = document.getElementById("ExitModalPhoneForm");
      }
      if (!target) { if (err) err.hidden = false; input.focus(); return; }
      if (err) err.hidden = true;
      if (target.id === "ExitModalEmailForm") klaviyoIdentify(raw, function () { target.submit(); });
      else target.submit();
    });
    if (x.hasAttribute("data-autopen")) { open(); return; }
    var seen = false;
    try { seen = localStorage.getItem(EXIT_KEY) === "1"; } catch (e) {}
    var delay = parseFloat(x.getAttribute("data-delay-seconds") || "12");
    if (seen || designMode()) return;
    /* 19 Oct (founder): the note comes only after the visitor has seen the whole lineup, all four flavours.
       Home: when the lineup's last box has opened (tg-home.js sends tg:lineup-seen), or once they have scrolled
       past the lineup. Pages without the lineup: after the delay setting (at least 40 s) or at the footer.
       All of it starts only once the loader has lifted. */
    function arm() {
      var later = function () { setTimeout(open, 1200); };
      function onView(el, fn, margin) {
        if (!el || !("IntersectionObserver" in window)) return;
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); fn(); } }, { rootMargin: margin || "0px" });
        io.observe(el);
      }
      var line = document.querySelector("[data-lineslide]");
      if (line) {
        document.addEventListener("tg:lineup-seen", later, { once: true });
        var after = line.closest(".shopify-section");
        after = after && after.nextElementSibling;
        onView(after, later, "0px 0px -40% 0px");
        return;
      }
      setTimeout(open, Math.max(40, delay) * 1000);
      onView(document.querySelector(".tg-footer"), later);
    }
    var html = document.documentElement;
    if (!html.classList.contains("tg-loader-on")) arm();
    else new MutationObserver(function (m, mo) { if (!html.classList.contains("tg-loader-on")) { mo.disconnect(); arm(); } }).observe(html, { attributes: true, attributeFilter: ["class"] });
  }

  /* ---------------------------------------------------- the goodness page */
  function wireGoodness(root) {
    if (root._tg) return;
    root._tg = true;
    var api = (root.getAttribute("data-api") || "").replace(/\/$/, "");
    var lastEmail = "";
    function step(s) {
      root.setAttribute("data-step", s);
      var head = root.querySelector('[data-for="' + s + '"] h1');
      if (head) { head.setAttribute("tabindex", "-1"); head.focus({ preventScroll: true }); }
    }
    function err(sel, msg) { var e = root.querySelector(sel); if (e) { e.textContent = msg || ""; e.hidden = !msg; } }
    function call(path, body) {
      return fetch(api + path, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
    }
    var emailForm = root.querySelector("[data-goodness-email]");
    if (emailForm) emailForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = emailForm.querySelector("input[type=email]").value.trim();
      err("[data-goodness-email-error]", "");
      if (!api) { err("[data-goodness-email-error]", "This page is not fully set up yet — API URL missing."); return; }
      lastEmail = email;
      step("loading");
      call("/check", { email: email }).then(function (d) {
        if (d.status === "reviewed") step("coupon");
        else if (d.status === "needs_review") step("review");
        else { step("email"); err("[data-goodness-email-error]", "Please enter a valid email."); }
      }).catch(function () { step("email"); err("[data-goodness-email-error]", "Something went wrong — please try again."); });
    });
    var reviewForm = root.querySelector("[data-goodness-review]");
    if (reviewForm) reviewForm.addEventListener("submit", function (e) {
      e.preventDefault();
      err("[data-goodness-review-error]", "");
      var rating = (reviewForm.querySelector("input[name=rating]:checked") || {}).value || "5";
      var review = reviewForm.querySelector("textarea").value.trim();
      var btn = reviewForm.querySelector("[type=submit]");
      if (btn) btn.setAttribute("aria-busy", "true");
      call("/review", { email: lastEmail, rating: rating, review: review }).then(function (d) {
        if (d.status === "thanks") step("thanks");
        else err("[data-goodness-review-error]", d.message || "Please try again.");
      }).catch(function () { err("[data-goodness-review-error]", "Something went wrong — please try again."); })
        .then(function () { if (btn) btn.removeAttribute("aria-busy"); });
    });
  }

  /* ------------------------------------- the bin: click the wrapper and it goes in the hole */
  function wireBin(sec) {
    if (sec._bin) return;
    sec._bin = true;
    var stage = sec.querySelector("[data-bin-stage]"), wrap = sec.querySelector("[data-bin-wrapper]"),
        hole = sec.querySelector("[data-bin-hole]"), done = sec.querySelector("[data-bin-done]"), again = sec.querySelector("[data-bin-again]");
    if (!stage || !wrap || !hole) return;
    var busy = false;
    /* the wrapper only hops while the stage is on screen */
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { sec.toggleAttribute("data-awake", en[0].isIntersecting); }, { threshold: 0.35 }).observe(stage);
    } else sec.setAttribute("data-awake", "");
    function box(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width, h: r.height }; }
    function finish() {
      sec.removeAttribute("data-flying");
      sec.setAttribute("data-binned", "");
      if (done) done.textContent = sec.getAttribute("data-done") || "";
      busy = false;
      setTimeout(function () { if (again && sec.hasAttribute("data-binned")) again.hidden = false; }, 1400);
    }
    function bin() {
      if (busy || sec.hasAttribute("data-binned")) return;
      busy = true;
      sec.setAttribute("data-flying", "");
      if (REDUCE || !wrap.animate) { wrap.style.visibility = "hidden"; finish(); return; }
      /* the flat wrapper is scrunched into a ball in the first part of the throw; the ball is what fits the hole */
      var flat = wrap.querySelector(".tg-bin__flat"), ball = wrap.querySelector(".tg-bin__ball");
      var a = box(wrap), b = box(hole), bw = ball ? box(ball).w : a.w, dx = b.x - a.x, dy = b.y - a.y, s = Math.max(0.1, (b.w * 0.95) / bw);
      if (flat && ball) {
        flat.animate([{ opacity: 1, transform: "scale(1)" }, { opacity: 0, transform: "scale(.45) rotate(-25deg)" }], { duration: 300, easing: "ease-in", fill: "forwards" });
        ball.animate([{ opacity: 0, transform: "scale(1.7) rotate(20deg)" }, { opacity: 1, transform: "scale(1) rotate(0deg)" }], { duration: 300, easing: "ease-out", fill: "forwards" });
      }
      /* a short throw, up and over, spinning and shrinking to the hole's size: a curve sampled into keyframes */
      var lift = Math.min(dy, 0) - Math.max(70, a.h * 1.3), frames = [], n = 18;
      for (var i = 0; i <= n; i++) {
        var t = i / n, u = 1 - t, x = 2 * u * t * dx * 0.45 + t * t * dx, y = 2 * u * t * lift + t * t * dy;
        frames.push({ transform: "translate(" + x.toFixed(1) + "px," + y.toFixed(1) + "px) rotate(" + (-300 * t).toFixed(1) + "deg) scale(" + (1 + (s - 1) * t * t).toFixed(3) + ")" });
      }
      var fly = wrap.animate(frames, { duration: 760, easing: "cubic-bezier(.35,.05,.55,1)", fill: "forwards" });
      fly.onfinish = function () {
        /* into the hole: a copy inside the round, clipped hole shrinks away into the dark */
        var img = (ball || wrap.querySelector("img")).cloneNode();
        img.removeAttribute("loading");
        img.className = "tg-bin__gone";
        img.style.width = (bw * s) + "px";
        hole.appendChild(img);
        wrap.style.visibility = "hidden";
        var sink = img.animate([
          { transform: "translate(-50%, -50%) rotate(-300deg) scale(1)", filter: "brightness(1)", opacity: 1 },
          { transform: "translate(-50%, -50%) rotate(-330deg) scale(.2)", filter: "brightness(.2)", opacity: 0 }
        ], { duration: 340, easing: "cubic-bezier(.5, 0, .9, .6)", fill: "forwards" });
        sink.onfinish = function () { img.remove(); };
        stage.animate([{ transform: "none" }, { transform: "translateY(3px) scale(1.006)" }, { transform: "none" }], { duration: 280, delay: 140, easing: "ease-out" });
        finish();
      };
    }
    function reset() {
      if (busy) return;
      sec.removeAttribute("data-binned");
      if (done) done.textContent = "";
      if (again) again.hidden = true;
      if (wrap.getAnimations) wrap.getAnimations({ subtree: true }).forEach(function (an) { an.cancel(); });
      wrap.style.visibility = "";
      if (!REDUCE && wrap.animate) wrap.animate([
        { transform: "translateY(-50vh) rotate(25deg)", opacity: 0 },
        { transform: "translateY(0) rotate(0deg)", opacity: 1, offset: 0.7 },
        { transform: "translateY(-10%) rotate(-3deg)", offset: 0.85 },
        { transform: "none" }
      ], { duration: 900, easing: "ease-out" });
      wrap.focus({ preventScroll: true });
    }
    wrap.addEventListener("click", bin);
    if (again) again.addEventListener("click", reset);
  }

  /* ------------------------------------- the Trigger Wall: write it on a note, get your own code */
  function postJSON(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return { status: "error" }; }); });
  }
  function formFail(err, msg, field) {
    err.textContent = msg;
    err.hidden = false;
    if (field) { field.setAttribute("aria-invalid", "true"); field.focus(); }
  }
  function wireTrigger(sec) {
    if (sec._tw) return;
    sec._tw = true;
    var api = (sec.getAttribute("data-api") || "").replace(/\/$/, "");
    var form = sec.querySelector("[data-trigger-form]");
    if (!form) return;
    var text = form.querySelector("[data-trigger-text]"), left = form.querySelector("[data-trigger-left]"), err = form.querySelector("[data-trigger-err]");
    var thanks = sec.querySelector("[data-trigger-thanks]"), already = sec.querySelector("[data-trigger-already]");
    function count() { if (left) left.textContent = String(160 - text.value.length); }
    text.addEventListener("input", count);
    count();
    form.addEventListener("input", function (e) { if (e.target.removeAttribute) e.target.removeAttribute("aria-invalid"); err.hidden = true; });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var f = form.elements, fail = function (m, el) { formFail(err, m, el); };
      var body = { trigger: f.trigger.value.replace(/\s+/g, " ").trim(), first_name: f.first_name.value.trim(), city: f.city.value.trim(),
        email: f.email.value.trim(), consent: f.consent.checked, website: f.website.value };
      if (body.trigger.length < 4) return fail("Write a few words first.", f.trigger);
      if (!body.first_name) return fail("Your first name goes under the note.", f.first_name);
      if (!body.city) return fail("Which city are you in?", f.city);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(body.email)) return fail("That email doesn't look right.", f.email);
      if (!body.consent) return fail("Tick the box so we can put it on the wall and send your code.", f.consent);
      if (!api) return fail("The wall isn't switched on yet. Please try again soon.");
      form.setAttribute("aria-busy", "true");
      postJSON(api + "/submit", body).then(function (d) {
        if (d.status === "ok" && d.code) {
          setText(sec, "[data-trigger-code]", d.code);
          var cp = thanks.querySelector("[data-copy]");
          if (cp) cp.setAttribute("data-copy", d.code);
          form.hidden = true; thanks.hidden = false; thanks.focus({ preventScroll: true });
        } else if (d.status === "already") {
          form.hidden = true; already.hidden = false; already.focus({ preventScroll: true });
        } else fail(d.message || "That didn't go through. Please try again.");
      }).catch(function () { fail("That didn't go through. Please check your connection and try again."); })
        .then(function () { form.removeAttribute("aria-busy"); });
    });
  }
  /* the free-box page: the approval email links here with ?t=<token> */
  function wireClaim(sec) {
    if (sec._tc) return;
    sec._tc = true;
    var api = (sec.getAttribute("data-api") || "").replace(/\/$/, "");
    var t = new URLSearchParams(location.search).get("t") || "";
    var form = sec.querySelector("[data-claim-form]"), err = sec.querySelector("[data-claim-err]");
    function step(s) {
      sec.setAttribute("data-step", s);
      var p = sec.querySelector('[data-for="' + s + '"]');
      if (p && s !== "form" && s !== "loading") p.focus({ preventScroll: true });
    }
    function fill(d) {
      setText(sec, "[data-claim-name]", d.first_name || "You");
      setText(sec, "[data-claim-text]", d.trigger || "");
      setText(sec, "[data-claim-by]", "\u2014 " + (d.first_name || "") + (d.city ? ", " + d.city : ""));
      var c = form.querySelector('[name="city"]');
      if (c && d.city && !c.value) c.value = d.city;
    }
    if (designMode()) { fill({ first_name: "Your name", city: "your city", trigger: "Their trigger shows here." }); step("form"); }
    else if (!api || !t) step("invalid");
    else fetch(api + "/claim?t=" + encodeURIComponent(t)).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status === "ok") { fill(d); step("form"); } else step(d.status === "claimed" ? "claimed" : "invalid");
    }).catch(function () { step("invalid"); });
    form.addEventListener("input", function (e) { if (e.target.removeAttribute) e.target.removeAttribute("aria-invalid"); err.hidden = true; });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var f = form.elements, fail = function (m, el) { formFail(err, m, el); };
      var phone = f.phone.value.replace(/\D/g, "").replace(/^(91|0)(?=\d{10}$)/, "");
      var body = { t: t, flavour: (form.querySelector("[name=flavour]:checked") || {}).value, name: f.name.value.trim(), phone: phone,
        address1: f.address1.value.trim(), address2: f.address2.value.trim(), city: f.city.value.trim(), zip: f.zip.value.trim(), province: f.province.value };
      if (body.name.length < 2) return fail("Who is it for?", f.name);
      if (!/^[6-9]\d{9}$/.test(phone)) return fail("A 10-digit mobile number, please. The courier calls on it.", f.phone);
      if (body.address1.length < 5) return fail("House, building and street, please.", f.address1);
      if (!body.city) return fail("Which city?", f.city);
      if (!/^[1-9]\d{5}$/.test(body.zip)) return fail("A 6-digit PIN code, please.", f.zip);
      if (!body.province) return fail("Pick your state.", f.province);
      if (designMode()) return fail("This is the theme editor. The real page sends the address to the Trigger Wall worker.");
      form.setAttribute("aria-busy", "true");
      postJSON(api + "/claim", body).then(function (d) {
        if (d.status === "ok") step("done");
        else if (d.status === "claimed" || d.status === "invalid") step(d.status);
        else fail(d.message || "That didn't go through. Please try again.");
      }).catch(function () { fail("That didn't go through. Please check your connection and try again."); })
        .then(function () { form.removeAttribute("aria-busy"); });
    });
  }

  /* ------------------------------------- one set of delegated listeners */
  function selectTab(b) {
    var root = b.closest("[data-tg-source]"), id = b.getAttribute("data-src-tab");
    qsa(root, "[data-src-tab]").forEach(function (x) { var on = x === b; x.setAttribute("aria-selected", String(on)); x.tabIndex = on ? 0 : -1; });
    qsa(root, ".tg-source__panel").forEach(function (pn) { var on = pn.getAttribute("data-ing") === id; pn.hidden = !on; if (on) replayOne(pn); });
    root.setAttribute("data-ing", id);
  }
  function peel(n) {
    if (n.getAttribute("data-peeled") === "true") return;
    n.setAttribute("data-peeled", "true");
    setTimeout(function () { n.setAttribute("data-peeled", "false"); }, 3200);
  }

  document.addEventListener("click", function (e) {
    var t = e.target, b;
    if (!t || !t.closest) return;
    if ((b = t.closest("[data-add], [data-add-variant]"))) {
      e.preventDefault();
      var id = b.getAttribute("data-add"), v = b.getAttribute("data-add-variant") || variantFor(id);
      if (!v) { toast("This one is not on sale right now."); return; }
      var box = b.closest("[data-tg-buy]"), q = 1;
      if (box) { var o = box.querySelector("[data-buy-qty]"); q = +(o && o.textContent) || 1; }
      addToCart([{ id: +v, quantity: q }], b);
      return;
    }
    if ((b = t.closest("[data-cart-open]"))) { e.preventDefault(); refreshCart(); openCart(true); return; }
    if ((b = t.closest("[data-cart-close]"))) { openCart(false); return; }
    if ((b = t.closest("[data-cart-step]"))) { stepLine(b.getAttribute("data-key"), +b.getAttribute("data-cart-step")); return; }
    if ((b = t.closest("[data-cart-checkout]")) && b.getAttribute("aria-disabled") === "true") { e.preventDefault(); return; }
    if ((b = t.closest("[data-buy-step]"))) {
      var o2 = b.closest("[data-tg-buy]").querySelector("[data-buy-qty]");
      o2.textContent = String(Math.max(1, Math.min(20, (+o2.textContent || 1) + (+b.getAttribute("data-buy-step"))))); return;
    }
    if ((b = t.closest("[data-buy-thumb]"))) {
      var bb = b.closest("[data-tg-buy]"), main = bb.querySelector("[data-buy-main]");
      main.src = b.getAttribute("data-buy-thumb"); main.alt = b.getAttribute("data-alt") || "";
      main.style.objectFit = b.getAttribute("data-fit") || "";
      if (b.getAttribute("data-srcset")) main.setAttribute("srcset", b.getAttribute("data-srcset")); else main.removeAttribute("srcset");
      qsa(bb, "[data-buy-thumb]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      replayOne(main.closest(".tg-switch")); return;
    }
    if ((b = t.closest("[data-src-tab]"))) { selectTab(b); return; }
    if ((b = t.closest("[data-film-step]"))) { stepFilm(b); return; }
    if ((b = t.closest("[data-carousel-next]"))) {
      var sl = qsa(b.closest("[data-tg-carousel]"), ".tg-carousel__slide"), k = 0;
      sl.forEach(function (s, j) { if (s.classList.contains("is-on")) k = j; });
      sl[k].classList.remove("is-on"); sl[(k + 1) % sl.length].classList.add("is-on"); return;
    }
    if ((b = t.closest("[data-tg-sticky]"))) { peel(b); return; }
    if ((b = t.closest("[data-exit-close]"))) { var x = b.closest("[data-tg-exit]"); if (x && x._close) x._close(); else if (x) x.setAttribute("data-open", "false"); return; }
    if ((b = t.closest("[data-copy]"))) {
      var txt = b.getAttribute("data-copy"), was = b.textContent;
      try { var pr = navigator.clipboard && navigator.clipboard.writeText(txt); if (pr && pr.catch) pr.catch(function () {}); } catch (x2) {}
      b.textContent = "Copied"; setTimeout(function () { b.textContent = was; }, 1800); return;
    }
    if ((b = t.closest(".tg-menu a"))) { var m = b.closest("details"); if (m) m.removeAttribute("open"); }
  });
  document.addEventListener("input", function (e) {
    var r = e.target;
    if (!r.classList || !r.classList.contains("tg-compare__range")) return;
    var c = r.closest("[data-tg-compare]");
    c.style.setProperty("--x", r.value + "%"); c.setAttribute("data-touched", "");
  });
  document.addEventListener("keydown", function (e) {
    var t = e.target;
    if (t.matches && t.matches("[data-tg-sticky]") && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); peel(t); }
    if (t.matches && t.matches("[data-src-tab]") && (e.key === "ArrowRight" || e.key === "ArrowLeft")) {
      var tabs = qsa(t.parentNode, "[data-src-tab]"), i = tabs.indexOf(t) + (e.key === "ArrowRight" ? 1 : -1), nx = tabs[(i + tabs.length) % tabs.length];
      selectTab(nx); nx.focus(); e.preventDefault();
    }
    if (e.key === "Escape") {
      openCart(false);
      qsa(document, "[data-tg-exit][data-open=true]").forEach(function (x) { if (x._close) x._close(); });
      qsa(document, ".tg-menu[open]").forEach(function (m) { m.removeAttribute("open"); });
    }
  });

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize);
  /* Safari restores the previous page from memory on Back, with the old cart on screen */
  window.addEventListener("pageshow", function (e) { if (e.persisted) refreshCart(); });
  /* the theme editor re-renders one section at a time */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); wireExit(); });

  function boot() { init(document); wireExit(); refreshCart(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();

  window.Trigrrr = { init: init, money: money, cart: { add: addToCart, open: openCart, refresh: refreshCart } };
})();
